import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import mainHelper, {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class WarehouseDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            isLoad:true,
            branches: [],
            warehouse: null,
            formData : {
                name:'',
                code:'',
                branch_id:'',
                address:'',
                phone:'',
                email:'',
                manager_name:'',
                is_active: true
            }
        }
    }

    async componentDidMount() {
        await Promise.all([
            this.fetchBranches(),
            this.fetchWarehouseDetails()
        ]);
        this.setState({isLoad: false});
    }

    fetchBranches = async () => {
        try {
            const response = await apiCall('business/branches/get-branches','get');
            this.setState({branches: response});
        } catch (e) {
            console.error(e);
        }
    }

    fetchWarehouseDetails = async () => {
        const {id} = this.props.match.params;
        try {
            const response = await apiCall(`business/stock/warehouse/info/${id}`,'get');
            if(response.status === 'success') {
                const warehouseData = response.data;
                this.setState({
                    warehouse: warehouseData,
                    formData: {
                        name: warehouseData.name || '',
                        code: warehouseData.code || '',
                        branch_id: warehouseData.branch_id || '',
                        address: warehouseData.address || '',
                        phone: warehouseData.phone || '',
                        email: warehouseData.email || '',
                        manager_name: warehouseData.manager_name || '',
                        is_active: warehouseData.is_active
                    }
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (e) => {
        const {id,value,type,checked} = e.target;
        this.setState(prevState => ({
            formData : {
                ...prevState.formData,
                [id] : type === 'checkbox' ? checked : value
            }
        }))
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({loading:true});
        const {formData} = this.state;
        const {id} = this.props.match.params;
        const warehouseFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            warehouseFormData.append(key,formData[key]);
        });

        try {
            const response = await apiCall(`business/stock/warehouse/update/${id}`,'post',warehouseFormData);
            this.setState({loading:false});
            mainHelper.toastMessage(response.status,response.message);
        }catch (e) {
            this.setState({loading:false});
        }
    }

    render() {
        const {loading, branches, formData, isLoad} = this.state;

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div className="page-loader-wrapper" style={{display: isLoad ? 'block' : 'none'}}>
                    <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <div className="m-t-30">
                            <img src={require('../../../assets/images/logo-white.png')} width="150" alt="Servicezone"/>
                        </div>
                        <p>Yükleniyor</p>
                        <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                    </div>
                </div>
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Depo Düzenle"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Depolar", navigate: "stock/warehouses" },
                                { name: "Depo Düzenle", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Depo Adı *</label>
                                                    <input
                                                        id="name"
                                                        className="form-control"
                                                        placeholder="Depo Adı"
                                                        type="text"
                                                        value={formData.name}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Depo Kodu *</label>
                                                    <input
                                                        id="code"
                                                        className="form-control"
                                                        placeholder="Depo Kodu"
                                                        type="text"
                                                        value={formData.code}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Şube</label>
                                                    <select
                                                        id="branch_id"
                                                        className="form-control"
                                                        value={formData.branch_id}
                                                        onChange={this.handleChange}
                                                    >
                                                        <option value="">Şube Seçin</option>
                                                        {branches.map(branch => (
                                                            <option key={branch.id} value={branch.id}>
                                                                {branch.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Sorumlu Kişi</label>
                                                    <input
                                                        id="manager_name"
                                                        className="form-control"
                                                        placeholder="Sorumlu Kişi"
                                                        type="text"
                                                        value={formData.manager_name}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Telefon</label>
                                                    <input
                                                        id="phone"
                                                        className="form-control"
                                                        placeholder="Telefon"
                                                        type="text"
                                                        value={formData.phone}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>E-posta</label>
                                                    <input
                                                        id="email"
                                                        className="form-control"
                                                        placeholder="E-posta"
                                                        type="email"
                                                        value={formData.email}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="form-group">
                                                    <label>Adres</label>
                                                    <textarea
                                                        id="address"
                                                        className="form-control"
                                                        placeholder="Adres"
                                                        rows="3"
                                                        value={formData.address}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="form-group">
                                                    <label>
                                                        <input
                                                            id="is_active"
                                                            type="checkbox"
                                                            checked={formData.is_active}
                                                            onChange={this.handleChange}
                                                        />
                                                        {' '}Aktif
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block" disabled={true} style={{textAlign: "-webkit-center"}}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) :
                                                <button className="btn btn-outline-primary btn-block" type="submit">
                                                    Güncelle
                                                </button>}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(WarehouseDetail));

